export const bankVerifyConfig = {
    bankVerify: 'ตรวจสอบบัญชี',
    allowManualInput:'อนุญาตให้กรอกชื่อบัญชีเอง'
}